import React, { useEffect, useState } from 'react';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import utils from 'components/utils';
import NumericStepper from 'components/NumericStepper';

const SelectQuantity = props => {
	const { item } = props;
	const saveNewQuantity = useStoreActions(dispatch => dispatch.cart.deleted.saveNewQuantity);

	const selectQuantity = newQta => {
		saveNewQuantity({ catalog: item.catalog, quantty: newQta });
	};

	return (
		<NumericStepper
			removeDot
			precision={0}
			value={item.quantityRequiredNew}
			onChange={numberAsValue => selectQuantity(numberAsValue)}
			max={999}
			min={1}
			strict
		/>
	);
};

export default SelectQuantity;
